module.exports = __webpack_public_path__ + "img/font.f23ef1d5.svg";